import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { sendFunnelStepGTM } from './sendFunnelStepGTM'
import { FunnelStep } from './types'
import { ApplicationState } from '../../reducers'
import useCompany from '../../hooks/useCompany'

export function useRegisterFunnelStep(funnelStep: FunnelStep, isSubmit?: boolean): void {
  const quote = useSelector((state: ApplicationState) => state.quote.data)
  const { company } = useCompany()
  useEffect(() => {
    sendFunnelStepGTM(quote, funnelStep, company, isSubmit)
  }, [funnelStep])
}
